import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { automationApi, type BusinessRule } from '../../api/automation';
import { BusinessRuleEnginePanel } from '../../components/automationstudio/BusinessRuleEnginePanel';

export function RuleBuilderPage() {
  const [rules, setRules] = useState<BusinessRule[]>([]);
  const [name, setName] = useState('');
  const [domain, setDomain] = useState('inventory');
  const [expression, setExpression] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(() => {
    void automationApi.listRules().then((r) => setRules(r.rules ?? [])).catch((e) => setError(String(e)));
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = async () => {
    if (!name || !expression) return;
    try {
      await automationApi.createRule({ name, domain, expression, active: true });
      setName(''); setExpression('');
      load();
    } catch (e) {
      setError(String(e));
    }
  };

  const panelRules = rules.map((r) => ({
    name: r.name,
    feature: r.domain,
    priority: r.priority,
    active: r.active,
  }));

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Rule Builder</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Business rules engine with decision tables and conditional logic.</p>
        </div>
        <Link to="/automation" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Automation Hub</Link>
      </div>
      <div className="mt-6 grid gap-3 sm:grid-cols-3">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Rule name" className="rounded-lg border px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-900" />
        <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="Domain" className="rounded-lg border px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-900" />
        <input value={expression} onChange={(e) => setExpression(e.target.value)} placeholder="Expression" className="rounded-lg border px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-900" />
      </div>
      <button onClick={create} className="mt-3 rounded-lg bg-brand-600 px-4 py-2 text-sm text-white hover:bg-brand-700">Create Rule</button>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6">
        <BusinessRuleEnginePanel rules={panelRules} />
      </div>
    </div>
  );
}
